import type { EmployerGuideContext, GuideContext } from '@/shared/api/onboarding';
import type { GuideStep } from './types';

/** Resolve a step's CTA to a concrete href (internal path or external URL), or null. */
export function resolveCtaHref(step: GuideStep, ctx: GuideContext | undefined): string | null {
  const cta = step.cta;
  if (!cta) return null;
  if (cta.href) return cta.href;
  const emp = ctx as EmployerGuideContext | undefined;
  if (cta.hrefToken === 'registrationUrl') {
    return (
      emp?.ausgleichskasse?.householdPortalUrl ||
      emp?.ausgleichskasse?.website ||
      emp?.simplifiedProcedure?.registrationUrl ||
      emp?.taxAuthorityUrl ||
      null
    );
  }
  if (cta.hrefToken === 'taxAuthorityUrl') return emp?.taxAuthorityUrl || null;
  return null;
}
